// extracted by mini-css-extract-plugin
export default {"container":"styles_container__x0r6H","iframe":"styles_iframe__929M9","iframeForDashboard":"styles_iframeForDashboard__CAjR4","backArrow":"styles_backArrow__UZ3r-"};